import { ca } from '@cian/analytics';
import { EButtonType } from '@cian/frontend-newbuilding-broker-component';

import { TJsonQuery } from '../../../../packages/JsonQuery';

const BUTTON_TYPE_TO_EVENTS_MAP = {
  [EButtonType.Next]: 'PopUpConfirm',
  [EButtonType.Go]: 'PopUpLanding',
};

const BROKER_NAME_MAP: Record<string, string> = {
  ['Метрис']: 'metris',
  ['Тренд']: 'trend',
};

export const trackNextOrGoButtonClick = (sc: TJsonQuery, buttonType: EButtonType, brokerName: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Click',
    label: BUTTON_TYPE_TO_EVENTS_MAP[buttonType],
    sc,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        broker_name: BROKER_NAME_MAP[brokerName],
      },
    },
    useLastProducts: true,
  });
};
